/**
 * @file 加载图标的svg
 * @author caifeng01
 */
import * as React from 'react';
import classNames from 'classnames';

var LoadingIcon = function LoadingIcon(_ref) {
  var prefixCls = _ref.prefixCls,
      className = _ref.className;
  var contextClassname = classNames(className, "".concat(prefixCls, "-begin"));
  return /*#__PURE__*/React.createElement("svg", {
    className: contextClassname,
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle1",
    cx: "511.1",
    cy: "108.6",
    r: "102.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle2",
    cx: "862.1",
    cy: "309.6",
    r: "102.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle3",
    cx: "862.1",
    cy: "712.4",
    r: "102.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle4",
    cx: "511.1",
    cy: "917.8",
    r: "102.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle5",
    cx: "159.7",
    cy: "712.4",
    r: "102.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle6",
    cx: "159.7",
    cy: "309.6",
    r: "102.6"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "frame",
    points: "511.1,108.6 861.8,311.2 862.1,712.4 511.1,917.8 159.7,712.4 146,309.6",
    fill: "none",
    strokeWidth: "50",
    strokeMiterlimit: "10",
    stroke: "inherit"
  }));
};

export default LoadingIcon;